// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"32866711","453":"efc57750","732":"1cbf80b9","977":"4539ac47"}[chunkId] + ".chunk.js";
};